// External
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

// Internal
import { requiredEmpty, url } from 'shared/utils/formValidation';
import {
  getEditorButtonModalInitialValues,
} from 'state/marketing/emailFlow/emailFlowManagement/selectors';
import { EMAIL_FLOW_EDITOR_BUTTON_MODAL } from 'shared/constants/forms';
import { StoreState } from 'state/rootReducer';
import Modal from 'ui/new/modal';
import Button from 'ui/new/button';
import { Input } from 'ui/new/form';

import style from './EditorModal.scss';

interface DispatchProps {
  handleSubmit: (onClickSave: Function) => void;
  onCloseClick: () => void;
  onAddURL: (
    textSelected: string,
    inputUrl: string,
  ) => void;
}

interface ButtonModal {
  textSelected: string,
  inputUrl: string,
}

interface EditorButtonModalProps extends DispatchProps {}

const EditorButtonModal = ({
  handleSubmit,
  onCloseClick,
  onAddURL,
}: EditorButtonModalProps) => {
  const onClickSave = React.useCallback(({
    textSelected,
    inputUrl,
  }: ButtonModal) => {
    onAddURL(textSelected, inputUrl);
  }, [onAddURL]);

  return (
    <form onSubmit={handleSubmit(onClickSave)}>
      <div className={style.modal}>
        <Modal show title="Editar Botão" onClose={onCloseClick} classes={style} width={500}>
          <Modal.Body>
            <p>Texto do botão</p>
            <Field
              type="text"
              name="textSelected"
              component={Input}
              validate={[requiredEmpty]}
            />
            <p className={style.titleField}>Endereço do link no botão</p>
            <Field
              type="text"
              name="inputUrl"
              component={Input}
              placeholder="http://www.site.com.br"
              validate={[requiredEmpty, url]}
            />
          </Modal.Body>
          <Modal.Footer align="right">
            <Button type="light" onClick={onCloseClick}>CANCELAR</Button>
            <Button type="success" submit>SALVAR</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </form>
  );
};

const mapStateToProps = (state: StoreState) => ({
  initialValues: getEditorButtonModalInitialValues(state),
});

export default connect(mapStateToProps)(
  reduxForm({ form: EMAIL_FLOW_EDITOR_BUTTON_MODAL })(EditorButtonModal),
);
